import { useState, useCallback } from 'react';
import { setWholesaleUser } from '../../API/ProtectedAuth';
import { handleApiError } from '../../Utils/errorHandler';

export default function useSetWholesale({ onSuccess } = {}) {
  const [loadingId, setLoadingId] = useState(null);
  const [error, setError] = useState(null);

  const clearError = useCallback(() => setError(null), []);

  const setWholesale = useCallback(async (userId, isWholesale) => {
    setError(null);
    setLoadingId(userId);
    try {
      await setWholesaleUser(userId, isWholesale);
      if (typeof onSuccess === 'function') onSuccess();
    } catch (err) {
      const msg = handleApiError(err);
      setError(msg);
    } finally {
      setLoadingId(null);
    }
  }, [onSuccess]);

  return { setWholesale, loadingId, error, clearError };
}
